import { ECountry, EStreetType } from '@constants';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IAddressData {
  streetType?: EStreetType;
  address?: string;
  streetNumber?: string;
  postalCode?: string;
  city?: string;
  province?: string;
  countryResidence?: ECountry;
}

export const useFullAddress = (addressData?: IAddressData): string => {
  const { t } = useTranslation('DefaultTranslations');

  return useMemo(() => {
    if (!addressData) return '';

    const isSpanishAddress = addressData.countryResidence === ECountry.ES;
    const streetTypeName =
      isSpanishAddress && addressData.streetType ? t(addressData.streetType) : '';
    const streetWithNumber = [streetTypeName, addressData.address, addressData.streetNumber]
      .filter(Boolean)
      .join(' ');

    const regionOrCountry = isSpanishAddress ? addressData.province : addressData.countryResidence;

    const parts = [
      streetWithNumber,
      addressData.postalCode,
      addressData.city,
      regionOrCountry
    ].filter(Boolean);

    return parts.join(', ');
  }, [addressData, t]);
};
